import api from './api';

export interface StockAlertItem {
  sku: string;
  title: string;
  brand: string;
  category: string;
  qtyWanted: number;
  createdAt: string;
  status: 'active' | 'fulfilled';
  fulfilledAt: string | null;
  /** Prossimo arrivo dell'articolo, come sulla scheda; `null` se non previsto. */
  prossimArrivo?: string | null;
  qtaArrivo?: number | null;
}

export interface StockAlertListResponse {
  items: StockAlertItem[];
  total: number;
}

export const stockAlertsService = {
  list: async (): Promise<StockAlertListResponse> => {
    const { data } = await api.get<StockAlertListResponse>('/api/clienti/me/avvisi-stock');
    return data;
  },

  add: async (payload: {
    sku: string;
    title: string;
    brand: string;
    category: string;
    qtyWanted?: number;
  }): Promise<StockAlertItem> => {
    const { data } = await api.post<StockAlertItem>('/api/clienti/me/avvisi-stock', {
      ...payload,
      qtyWanted: payload.qtyWanted ?? 1,
    });
    return data;
  },

  remove: async (sku: string): Promise<void> => {
    await api.delete(`/api/clienti/me/avvisi-stock/${sku}`);
  },

  updateQty: async (sku: string, qtyWanted: number): Promise<StockAlertItem> => {
    const { data } = await api.patch<StockAlertItem>(`/api/clienti/me/avvisi-stock/${sku}`, { qtyWanted });
    return data;
  },
};
